// `receivedAt` is a UTC timestamp without timezone. Read it as UTC and format
// it directly so the displayed value is never shifted to the viewer's locale.
export const formatReceivedAt = (value: string) => {
  const date = new Date(`${value.trim()}Z`);

  return {
    date: new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    }).format(date),
    time: new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date),
  };
};
